import * as api from '../api';
import {
    HEALTHCARE_VENDOR_ORDERS_REQUEST,
    HEALTHCARE_VENDOR_ORDERS_SUCCESS,
    HEALTHCARE_VENDOR_ORDERS_FAIL,
} from "../constants/webOrderConstants";


// `opts.outletId`: the branch the navbar shows (undefined = every location this login may see).
export const fetchHealthcareVendorOrders = (vendorId, page = 1, limit = 10, opts = {}) => async (dispatch) => {
    try {
        dispatch({ type: HEALTHCARE_VENDOR_ORDERS_REQUEST });

        const { data } = await api.fetchHealthcareVendorOrdersApi(vendorId, page, limit, opts);

        dispatch({
            type: HEALTHCARE_VENDOR_ORDERS_SUCCESS,
            payload: data,
        });
    } catch (error) {
        dispatch({
            type: HEALTHCARE_VENDOR_ORDERS_FAIL,
            payload: error.response && error.response.data.message
                ? error.response.data.message
                : error.message,
        });
    }
};

